import { html, LitElement } from "lit-element";
import { classMap } from "lit-html/directives/class-map";
/// 화면 전체를 까맣게 만드는 방법
/// 최 상위에서 화면을 까맣게 만든다.
export class BlackScreen extends LitElement {
    constructor() {
        super(...arguments);
        this.visible = false;
    }
    createRenderRoot() {
        return this;
    }
    show() {
        this.visible = true;
        this.requestUpdate();
    }
    hide() {
        this.visible = false;
        this.requestUpdate();
    }
    render() {
        const klass = {
            dn: !this.visible,
        };
        return html `<div
      class="fixed top-0 bottom-0 left-0 right-0 bg-black ${classMap(klass)}"
    ></div>`;
    }
}
customElements.define("jh-black-screen", BlackScreen);
export function showBlackScreen() {
    const screen = $("jh-black-screen")[0];
    screen.show();
}
export function hideBlackScreen() {
    const screen = $("jh-black-screen")[0];
    screen.hide();
}
//# sourceMappingURL=blackScreen.js.map